// LayerSource — every VectorQueryResult carries one of these. L1 (certified
// templates) and L2 (studio precedents) are NEVER blended (Master Rule 1.3 →
// CLAUDE.md #3). Code that drops or merges this field is wrong.
import { z } from "zod";
export const LayerSourceSchema = z.enum(["L1", "L2"]);
export const LAYER_SOURCES = LayerSourceSchema.options;
export function isLayerSource(value) {
    return value === "L1" || value === "L2";
}
//# sourceMappingURL=LayerSource.js.map